var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManagers = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.453 23.857v-15h-5.375l-3.148 8.141-3.126-8.14H7.429v15h3.868v-9.76l3.778 9.76h1.71l3.8-9.76v9.76h3.868Z"
})));
export default SvgManagers;